import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'
import { getTenantFromHostname } from 'src/helpers/tenantUtils'

const axiosInstance = axios.create({
  baseURL: process.env.apiBaseUrl,
  withCredentials: true,
  timeout: 60000,
  headers: {
    'X-Application-Secret': `${process.env.apiSecret}`
  }
})

// Axios middleware to convert all api responses to camelCase
axiosInstance.interceptors.response.use((response: AxiosResponse) => {
  if (response.data && response.headers['content-type'].includes('application/json')) {
    response.data = camelizeKeys(response.data)
  }

  return response
})

// Axios middleware to convert all api requests to snake_case and handle tenant routing
axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
  const newConfig = { ...config }

  // Detect tenant and update base URL if needed
  if (typeof window !== 'undefined') {
    const tenant = getTenantFromHostname(window.location.hostname)
    if (tenant) {
      newConfig.headers = {
        ...newConfig.headers,
        'X-Tenant': tenant
      }
    }
  }

  newConfig.url = `${config.url}`
  if (newConfig.headers != null && newConfig.headers['Content-Type'] === 'multipart/form-data') {
    return newConfig
  }
  if (config.params) {
    newConfig.params = decamelizeKeys(config.params)
  }
  if (config.data) {
    newConfig.data = decamelizeKeys(config.data)
  }

  return newConfig
})

export default axiosInstance
